import { useEffect, useState } from "react";

export function useUnsavedQuestionNavigation(dirty, saving, savingRef) {
  const [pendingNavigation, setPendingNavigation] = useState(null);
  useEffect(() => {
    if (!dirty && !saving) return undefined;
    const warn = (event) => { event.preventDefault(); event.returnValue = ""; };
    window.addEventListener("beforeunload", warn);
    return () => window.removeEventListener("beforeunload", warn);
  }, [dirty, saving]);
  const requestNavigation = (action) => {
    if (saving || savingRef.current) return;
    if (dirty) setPendingNavigation(() => action);
    else action();
  };
  return { pendingNavigation, setPendingNavigation, requestNavigation };
}
